import React from 'react';
import PropTypes from 'prop-types';
import Modal from '../common/modal';
import UserChangePassword from '../../scenes/login/UserChangePassword';

const UserChangePasswordModal = ({ onClose, width }) => {
	return (
		<Modal title="change password" onClose={onClose} hasFooter={false} width={width} enableOverlayClickClose={false}>
			<UserChangePassword onDiscard={onClose} />
		</Modal>
	);
};
UserChangePasswordModal.propTypes = { onClose: PropTypes.func.isRequired, width: PropTypes.number };
export default UserChangePasswordModal;